<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-model="drawer"
                app
        >
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="title">
                        Digitab
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        mídia digital interna
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list shaped>
                <v-list-item-group v-model="menuItem" color="primary">
                    <v-list-item
                            link
                            @click="navTo(item)"
                            v-for="(item, i) in this.$router.options.routes"
                            :key="i"
                            v-if="typeof item.meta != 'undefined' && item.meta && typeof item.meta.showInMenu != 'undefined' && item.meta.showInMenu"
                    >
                        <v-list-item-action>
                            <v-icon>{{item.meta.icon}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{item.meta.title||item.name}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar
                app
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>{{$route.meta.title || $route.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click.stop="fGoDark()" v-on="on">
                        <!--                            <v-icon>mdi-brightness-4</v-icon>-->
                        <v-icon>mdi-theme-light-dark</v-icon>
                    </v-btn>
                </template>
                <span>tema escuro</span>
            </v-tooltip>
        </v-app-bar>

        <v-main>
            <v-container
                    fluid
                    style="height: 100%"
            >
                <v-row
                        align="stretch"
                        justify="center"
                        style="height: 100%"
                >
                    <v-col
                            class="pt-0 mt-0"
                    >
                        <slot></slot>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <!--                <v-footer-->
        <!--                        color="indigo"-->
        <!--                        app-->
        <!--                >-->
        <!--                    <span class="white&#45;&#45;text">&copy; 2019</span>-->
        <!--                </v-footer>-->
    </v-app>
</template>

<script>
    export default {
        props: {
            source: String,
        },
        data: () => ({
            title: "",
            menuItem: 0,
            drawer: null,
            goDark: false,
        }),
        created() {
            this.$vuetify.theme.dark = this.goDark;
        },
        mounted() {
            // this.activeMenu();
        },
        methods: {
            fGoDark() {
                this.goDark = !this.goDark;
                this.$vuetify.theme.dark = this.goDark;
            },
            navTo(itemRoute) {
                this.$router.push({path: itemRoute.path});
                // this.activeMenu();
            },
            activeMenu() {
                let routeBasePath = this.$route.path.split('/');

                for (var i in this.$router.options.routes) {
                    if (this.$router.options.routes[i].path == '/' + routeBasePath[1]) {
                        this.menuItem = parseInt(i);
                    }
                }
            },
        }
    }
</script>
